export default __webpack_public_path__ + "static/colibri-4-web-a4684418ddc0a2f0f0e2accfdb198a58.pdf";